import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';

/**
 * 自定义 Hook: 检测是否为移动端设备
 * 
 * 使用 Ant Design 的 useBreakpoint hook 来检测当前视口宽度。
 * 当屏幕宽度小于 768px (md 断点) 时返回 true。
 * 
 * Ant Design 断点定义:
 * - xs: < 576px
 * - sm: ≥ 576px
 * - md: ≥ 768px
 * - lg: ≥ 992px
 * - xl: ≥ 1200px
 * - xxl: ≥ 1600px
 * 
 * @returns {boolean} 如果是移动端返回 true，否则返回 false
 * 
 * @example
 * ```javascript
 * import useIsMobile from './hooks/useIsMobile';
 * 
 * function MyComponent() {
 *   const isMobile = useIsMobile();
 *   
 *   return (
 *     <div>
 *       {isMobile ? '移动端视图' : '桌面端视图'}
 *     </div>
 *   );
 * }
 * ```
 */
const useIsMobile = () => {
  const screens = useBreakpoint();
  return !screens.md; // 当 md 断点为 false 时，表示屏幕宽度 < 768px
};

export default useIsMobile;
